// Parsed with new URL() rather than substring-matched: "javascript:alert(1)//http://x"
// contains both "http" and "://", and assigning it to window.location.href runs it.
export function httpOrHttpsUrlOrNull(raw) {
  if (typeof raw !== "string" || raw.trim().length === 0) return null;
  let parsed;
  try {
    parsed = new URL(raw.trim());
  } catch (e) {
    return null; // not an absolute URL at all
  }
  return ["https:", "http:"].includes(parsed.protocol) ? parsed.href : null;
}

export function httpsUrlOrNull(raw) {
  const url = httpOrHttpsUrlOrNull(raw);
  return url && url.startsWith("https:") ? url : null;
}

export function withoutQueryString(url) {
  const queryStart = url.indexOf("?");
  return queryStart === -1 ? url : url.slice(0, queryStart);
}
